import { render, staticRenderFns } from "./login-company.vue?vue&type=template&id=0199105a&scoped=true"
import script from "./login-company.vue?vue&type=script&lang=js"
export * from "./login-company.vue?vue&type=script&lang=js"
import style0 from "./login-company.vue?vue&type=style&index=0&id=0199105a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0199105a",
  null
  
)

export default component.exports